export default "__VITE_ASSET__CWYEwJFW__"